import React, { Component } from "react";
import { Container, List, Segment, Button, Icon } from "semantic-ui-react";
import ReactTable from "react-table";

import request from "../../utils/request";

const resetState = () => {
  return {
    xhrStatus: "",
    xhrMessage: "",
    isLoading: false,
    signature: {
      fullreport: []
    }
  };
};

export const columns = [
  {
    accessor: "file",
    Header: "Filename"
  },
  {
    accessor: "md5",
    Header: "MD5 Signature"
  },
  {
    accessor: "sha256",
    Header: "SHA256 Signature"
  }
];

class SignatureView extends Component {
  constructor(props) {
    super(props);
    this.state = resetState();
  }
  componentDidMount = () => {
    if (this.props.match.params.id === ":id") {
      this.props.history.replace("/software-signature");
      return;
    } else {
      this.setState({ isLoading: true });
      request
        .get(this, `api:/signature/${this.props.match.params.id}`, {})
        .then(resp => {
          this.setState({
            signature: resp,
            isLoading: false
          });
        });
    }
  };
  componentWillUnmount = () => {
    this.setState(resetState());
  };
  handleChange = (e, { name, value }) => {
    let fd = this.state.formdata;
    fd[name] = value;
    this.setState({ formdata: fd });
  };
  exportReport = () => {
    this.setState({ isLoading: true });
    request
      .getDownload(this, `api:/signature/${this.props.match.params.id}`, { export: 1 })
      .then(resp => {
        this.setState({
          isLoading: false
        });
      });
  }
  render() {
    const { signature, isLoading } = this.state;
    return (
      <Container fluid>
        <Button type="button" onClick={this.exportReport} primary>
          <Icon name="download" />Export
        </Button>
        {signature.dateline && (
          <Segment inverted>
            <List divided inverted relaxed>
              <List.Item>
                <List.Content floated="right">
                  {signature.dateline}
                </List.Content>
                <List.Header>Date Recorded</List.Header>
              </List.Item>
              <List.Item>
                <List.Content floated="right">
                  {signature.totalFiles}
                </List.Content>
                <List.Header>File(s) scanned</List.Header>
              </List.Item>
              <List.Item>
                <List.Content floated="right">
                  {signature.final_md5}
                </List.Content>
                <List.Header>MD5 Signature</List.Header>
              </List.Item>
              <List.Item>
                <List.Content floated="right">
                  {signature.final_sha1}
                </List.Content>
                <List.Header>SHA1 Signature</List.Header>
              </List.Item>
            </List>
          </Segment>
        )}
        <ReactTable
          data={signature.fullreport}
          columns={columns}
          className="-striped -highlight"
          loading={isLoading} // Display the loading overlay when we need it
          resizable={false}
          filterable={true}
          sortable={true}
          minRows={0}
        />
      </Container>
    );
  }
}

export default SignatureView;
